import SlideInContactForm from './components/SlideInContactForm.vue';
import InitComponent from 'Modules/InitComponent';
import store from 'Stores/store';

const contactForm = document.getElementById('contact-slide-in');
const initComponent = new InitComponent({
  selectors: contactForm,
  components: { SlideInContactForm },
  template: '<SlideInContactForm />',
  store,
});

initComponent.init();
